const BASE = 4;
const x = (multiplier) => `${(multiplier || 0) * BASE}px`;
export const sizes = {
    x,
};
export const spaces = {
    x,
};
//# sourceMappingURL=helpers.js.map